module.exports = __webpack_public_path__ + "static/img/homes3.92b6d6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/home/homes3.png
// module id = B0CG
// module chunks = 2